import { render, staticRenderFns } from "./apply-certification.vue?vue&type=template&id=e81b0a86&scoped=true"
import script from "./apply-certification.vue?vue&type=script&lang=js"
export * from "./apply-certification.vue?vue&type=script&lang=js"
import style0 from "./apply-certification.vue?vue&type=style&index=0&id=e81b0a86&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e81b0a86",
  null
  
)

export default component.exports